import React, { useState, useEffect } from "react";
import { Col, Modal, Nav, Row, Tab, Image, Form, Button } from "react-bootstrap";
import "../Learning.css";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetCodeOfVoilationModule,
  selectCodeOfVoilationModule,
} from "../../../features/learning/CodeOfVoilationSlice";
import icTitle from "../../../assets/images/ic-edit-modal.svg";
import DeleteBox from "../../../assets/images/ic-deletebox2.svg";
import DeleteBox1 from "../../../assets/images/ic-deletebox.svg";
import Add from "../../../assets/images/ic-add2.svg";
import ADD from "../../../assets/images/ic-add.svg";
import { isAdmin } from "../../../features/localStorage";
import "bootstrap/dist/css/bootstrap.min.css";
import "../AdminModal.css";
import EditCodeViolationAccordion from "../accordion/EditCodeViolationAccordion";
import TextField from "../../../components/textField/TextField";
import { GetInsertCodeVoilation, selectInsertCodeVoilation } from "../../../features/learning/InsertCodeVolationSlice";
import { GetDeleteCVCompany, selectDeleteCVCompany } from "../../../features/learning/deleteCodeVCompanySlice";
import swal from "sweetalert";
import FileUpload from "../../../components/textField/FileUpload";
import Feedback from "../../../components/feedbackNote/Feedback";
import EmptyRow from "../../../components/emptyRow/EmptyRow";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ModalDelete from "../../../assets/images/delete-bin-line.svg";
// const companyGroupDataArr = [
//   {
//     companyId: "",
//     brief: "",
//     clause: "",
//     actionTaken: "",
//     groupName: ""
//   }
// ];
type newGroupData = {
  "companyId": string,
  "brief": string,
  "clause": string,
  "actionTaken": string,
  "groupName": string,
}
const CodeViolationsDetails = () => {
  const [modalShow, setModalShow] = useState(false);
  const [company, setCompany] = useState<string>();
  const [row, setRow] = useState<string>();

  
  

  const CodeOfVoilationModule = useAppSelector(selectCodeOfVoilationModule);
  const dispatch = useAppDispatch();
  const [groupName, setgroupName] = useState("");
  const [file, setFile] = useState("");
  const [yearId, setyearId] = useState("");
  const [brief, setbrief] = useState("");
  const [clause, setclause] = useState("");
  const [actionTaken, setactionTaken] = useState("");
  const [companyGroupData, setcompanyGroupData] = useState<any>([]);
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const InsertMaterial = useAppSelector(selectInsertCodeVoilation);
  const [modalShow1, setModalShow1] = useState(false);
  const handleClose1 = () => setModalShow1(false);
  // Modal Code end
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    var data ={
      groupName: groupName,
      "clouse": clause,
      "actionTaken": null,
      companyId: userDetailsJson.companyId,
      yearId:yearId,
      companyGroupData:[{
        companyId: userDetailsJson.companyId,
        brief: brief,
        clause: clause,
        actionTaken: actionTaken,
        groupName: groupName
      }]
  }

    await dispatch(GetInsertCodeVoilation(data));
    dispatch(GetCodeOfVoilationModule());
   // handleClose();
  };
  const addCompany = () => {
    const add = "true";
    setCompany(add);
   // addRow()
  
  };
  // const addRow = async() => {
  //   const add = "true";
  //   setRow(add);
  //   await setcompanyGroupData(s=>{
  //     return[...s,
  //       {
  //         companyId: userDetailsJson.companyId,
  //         brief: brief,
  //         clause: clause,
  //         actionTaken: actionTaken,
  //         groupName: groupName
  //       }]
  //   })
  // };
  const addRow = ()  => {
    let newGroupData : newGroupData = {
          companyId: userDetailsJson.companyId,
          brief: brief,
          clause: clause,
          actionTaken: actionTaken,
          groupName: groupName
    }

    let prevMessages : any[] = [...companyGroupData]
    prevMessages.push(newGroupData)
    setcompanyGroupData(prevMessages)
  }
  useEffect(() => {
    const data = 0;
    async function fetchLearningModuleData() {
      let sample = await dispatch(GetCodeOfVoilationModule());
    }
    fetchLearningModuleData();
  }, []);

  //console.log(CodeOfVoilationModule, "code of violation");
  const [deleteCompId, setdeleteCompId]=useState(null)

  const checkDeleteCompId=(id:any)=>{
    setdeleteCompId(id)
  }
  const onDeleteModalShow=()=>{
    setModalShow1(true)
  }
  const onDeleteCompany=async()=>{
    await dispatch(GetDeleteCVCompany(deleteCompId));  
    await dispatch(GetCodeOfVoilationModule());
    await setModalShow1(false)
    await window.location.reload();
  }
  return (
    <>
       <Feedback pageName="Code Violation"/>
      <Row>
        {/* <Col xs={12} style={styles.text1} className="ps-0 mt-4">
          Awareness {">"} code violations 2020-2021
        </Col> */}
        <Col
          xs={12}
          style={styles.text2}
          className=" cardheader ps-0 mt-1 mb-4"
        >
          Code violations 2020-2021
        </Col>
      </Row>
     

    
      <div style={styles.titlebg}>
      {isAdmin() &&  
        <Row>
          <Col className="mb-5">
          <div className="floating-label-group">
                                              <input
                                                type="text"
                                                id="title"
                                                required
                                                defaultValue={2022}
                                                className="textstyle"                                                                                           
                                              />
                                              <label className="floating-label">Financial Year </label>
                                            </div>
            {/* <TextField
              type="text"
              id="username"
              label="Financial year"
              placeholder="2020-2021"
            /> */}
          </Col>
          <Col>
            <FileUpload setFile={setFile} title="File" fileValue="" fileType="PDF"/>
          </Col>
          <Col>
            <div className="px-3">
              <span style={styles.heading1}>Last modified By</span>
              <br />
              <span style={styles.data}>Samir Bhor</span>
            </div>
          </Col>
          <Col>
            <div className="px-3">
              <span style={styles.heading1}>Modified on</span>
              <br />
              <span style={styles.data}>27-03-2021</span>
            </div>
          </Col>
        </Row>
        }
        <div style={styles.line}></div>
        <Row>
          <Col xs={12} className="">
            <div
              style={{ paddingLeft: "20px", paddingRight: "20px" }}
              className="desk"
            >
              <Row className="py-3">
                
                <Col sm={2} style={styles.heading}>
                {isAdmin() && <Form.Check type="checkbox" id="srno" label="Sr.No" /> }
                
               {userDetailsJson.isAdmin!==true?<label> Sr.No</label>:""}
                {/* {currentUserId() && <Form.Check type="checkbox" id="srno" label="" />  } */}
                         
                </Col>
                <Col sm={4} style={styles.heading}>
                  Brief details of violation
                </Col>
                <Col sm={2} style={styles.heading}>
                  Clause
                </Col>
                <Col sm={3} style={styles.heading}>
                  Action taken
                </Col>
                {isAdmin() &&
                <Col sm={1}>
                  
                  <Image src={Add} onClick={addCompany} />
                  {deleteCompId===null?
                  <Image src={DeleteBox}  className="float-end" />:
                  <Image src={DeleteBox1} onClick={onDeleteModalShow} className="float-end" />
                  }
                </Col>
                  }
              </Row>
            </div>
            <div style={styles.line}></div>
            {company && (
              <form >
               
                  
              
              <div
                style={{ paddingLeft: "20px", paddingRight: "20px" }}
                className="desk"
              >
                <Row style={{ paddingTop: "18px", paddingBottom: "18px" }}>
                  <Col sm={4} style={{ paddingLeft: "54px" }}>
                    <input
                      type="text"
                      style={styles.data1}
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>,
                      ): void => setgroupName(ev.target.value)}
                      className="shadow-none"
                      placeholder="Enter company name"
                    />
                  </Col>
                </Row>
                 {companyGroupData.map((item:any,index:any)=>{
                   return(
                   <>
                
                <Row>
                  <div style={styles.line}></div>
                </Row>
                <Row style={{ paddingTop: "18px", paddingBottom: "18px" }}>
                  <Col sm={2} style={styles.id} className="desk">
                    {index+1}.
                  </Col>
                  <Col sm={4}>
                    <input
                      type="text"
                      style={styles.data1}
                      className="shadow-none"
                      placeholder="Add details"
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>,
                      ): void => setbrief(ev.target.value)}
                    />
                  </Col>
                  <Col sm={2}>
                    <input
                      type="text"
                      style={styles.data1}
                      className="shadow-none"
                      placeholder="Add clause"
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>,
                      ): void => setclause(ev.target.value)}
                    />
                  </Col>
                  <Col sm={2}>
                    <input
                      type="text"
                      style={styles.data1}
                      className="shadow-none"
                      placeholder="Add Action taken"
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>,
                      ): void => setactionTaken(ev.target.value)}
                    />
                  </Col>    
                               
                </Row>
               

                </> ) })}
                {isAdmin() &&
                <Row className="mb-3">
                  <Col sm={2}></Col>
                  <Col sm={6} style={styles.addrow}
                    onClick={addRow}
                    className="desk mt-2">
                  <Image src={ADD} />
                    ADD ROW
                  </Col> 
                  <Col sm={2}>
                  <Button onClick={handleSubmit}   type="button" style={styles.button}>  Save    </Button>
                  </Col> 
                </Row>  
                }           
            
              </div>
              </form>
            )}
            <Modal
                  show={modalShow1}
                  onHide={handleClose1}
                  backdrop="static"
                  size="lg"
                  keyboard={false}
                >
                  <ENGModalHeader icon={ModalDelete} title=" Delete Module " />
                  <ENGModalBody
                    contents={
                      <>
                        <Row style={styles.divWhite}>
                          <Col lg={12}>
                            <p style={styles.delcontent}>
                              Are you sure you want delete this module?
                            </p>
                          </Col>
                        </Row>
                      </>
                    }
                  />
                  <EmptyRow />
                  <EmptyRow />
                  <EmptyRow />
                  <EmptyRow />
                  <Row style={styles.divGrey}>
                    <Col sm={9}></Col>
                    <Col sm={3}>
                    <button type="button" className="mr-2" onClick={handleClose1}  style={styles.button1} >  CANCEL  </button> 
                    <button className="ml-2" type="button" onClick={onDeleteCompany} style={styles.button} >  DELETE  </button>              
                    </Col>
                  </Row>
                  
                </Modal>
            {CodeOfVoilationModule.length > 0 ? (
              CodeOfVoilationModule.map((item: any) => {
                return (
                  <>
                    <div style={styles.line}></div>
                    <EditCodeViolationAccordion
                      data={item.companyGroupData}
                      title={item.groupName}
                      id={item.id}
                      onDeleteCompany={checkDeleteCompId}
                    />
                  </>
                );
              })
            ) : (
              <span style={styles.text1}>No Records Available</span>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

const styles: any = {
  titlebg: {
    padding: "24px",
    margin: "0px",
    backgroundColor: "#ffffff",
  },
  addrow: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#e31837",
},
data: {
  fontFamily: "Saira",
  fontSize: "16px",
  fontWeight: "500",
  color: "black",
},



button: {
  padding: "13px 20px",
  fontFamily: "Saira",
  fontSize: "12px",
  fontWeight: 400,
  fontStretch: "normal",
  fontStyle: "normal",
  borderRadius: "0",
  backgroundColor: "#e31837",
  letterSpacing: "normal",
  border: "0px",
  color:"#fff",
  float:"right",

},
button1: {
  padding: "13px 20px",
  fontFamily: "Saira",
  fontSize: "12px",
  fontWeight: "500",
  fontStretch: "normal",
  fontStyle: "normal",
  borderRadius: "0",
  backgroundColor: "#ffffff",
  border:"1px solid #e31837",
  letterSpacing: "normal",    
  color:"#e31837"
},
divGrey: {
  backgroundColor: "rgb(250, 249, 249)",
  paddingTop: "20px",
  margin: "0px",
  paddingLeft: "10px",
  paddingRight: "10px",
  paddingBottom:"20px",
  borderTop: "1px solid #eee;"
},


  text1: {
    fontFamily: "Saira",
    fontSize: "10px",
    fontWeight: "500",
    color: "#979797",
  },
  text2: {
    fontFamily: "Saira",
    fontWeight: "500",
    color: "black",
  },
  line: {
    height: "1px",
    margin: "0px",
    backgroundColor: "#ededed",
  },
  heading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "black",
  },
  heading1: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "400",
    color: "black",
  },
};

export default CodeViolationsDetails;
